import type { ThunkDispatchCommon } from "single-spa/store/types";

import { resetSiteInfoAction } from "../../feed/store/action-creators";
import type { WebsiteType } from "../types";

import { selectWebsiteAction } from "./action-creators";

export function selectWebsiteThunk(website: WebsiteType) {
    return function (dispatch: ThunkDispatchCommon) {
        dispatch(selectWebsiteAction(website));
        dispatch(resetSiteInfoAction());
    };
}
